module.exports = __webpack_public_path__ + "img/dd.fe0fa0e4.png";